<div class="title" *ngIf="this.title">{{ title }}</div>
<p class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</p>

<form [formGroup]="formGroup">
  <div class="mat-form-field-wrapper">
    <div class="radio-group">
      <mat-radio-group
        [formControlName]="'answer'"
        [ngClass]="flexRow ? 'row' : 'column'"
      >
        <mat-radio-button
          [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
          [checked]="value"
          [disabled]="disabledYes"
          matTooltip="{{ tooltipYes }}"
          [matTooltipDisabled]="!disabledYes"
          (change)="answeredYes()"
          value="{{ true }}"
        >
          {{ yesLabel }}
        </mat-radio-button>
        <mat-radio-button
          [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
          [checked]="value === false"
          (change)="answeredNo()"
          value="{{ false }}"
          [disabled]="disabledNo"
          matTooltip="{{ tooltipNo }}"
          [matTooltipDisabled]="!disabledNo"
        >
          {{ noLabel }}
        </mat-radio-button>
        <mat-radio-button
          [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
          [checked]="value == null"
          (change)="answeredUnknown()"
          value="{{ null }}"
          [disabled]="disabledUnknown"
          matTooltip="{{ tooltipUnknown }}"
          [matTooltipDisabled]="!disabledUnknown"
        >
          {{ unknownLabel }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div
      *ngIf="
        (value === showExtraInstructionsOn || alwaysShowExtraInstructions) &&
        !neverShowExtraInstructions
      "
    >
      <textarea-input
        [subtitle]=""
        [placeholder]="extraInstructions"
        [initContent]="inputText"
        [answerChange]="answeredTextChange"
        [disabled]="disabled"
        [client]="client"
        [sensitive]="sensitiveText"
        (answer)="extraInstructionsChange($event)"
      ></textarea-input>
    </div>
  </div>
</form>
